// ABOUTME: Read-only renderer for tiptap JSON content.
// ABOUTME: Shared by the news article viewer, relation news viewer, and relation dashboard news block.

import { Box } from "@mui/material";
import { useEditor, EditorContent } from "@tiptap/react";
import { coreExtensions } from "./extensions/editorExtensions";

const ReadOnlyTiptap = ({ content, colors }) => {
    const editor = useEditor({
        extensions: coreExtensions,
        content: content || "",
        editable: false,
    });

    if (!editor) return null;

    return (
        <Box
            sx={{
                "& .ProseMirror": {
                    outline: "none",
                    fontSize: 14,
                    lineHeight: 1.4,
                    fontFamily: "Roboto, sans-serif",
                    color: colors.txt["primary"],
                    "& p": { margin: 0 },
                },
            }}
        >
            <EditorContent editor={editor} />
        </Box>
    );
};

export default ReadOnlyTiptap;
